// extracted by mini-css-extract-plugin
var _1 = "LeRguew1";
export { _1 as "breadcrumbs" }
